import Vue from 'vue'

export default {
  list: async () => {
    return Vue.axios.get('/institutions');
  },
  institution: async (code) => {
    return Vue.axios.get('/institutions/' + code);
  },
  save: async (institution) => {
    let formData = new FormData()
    for (const field in institution) if (institution.hasOwnProperty(field)) {
      formData.append('institution[' + field + ']', institution[field])
    }
    return Vue.axios.post('/institutions', formData);
  }
}
